import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { FiEdit3 } from 'react-icons/fi';
import { AiOutlineStop } from 'react-icons/ai';
import { AiOutlineEye } from 'react-icons/ai';
import { RiDeleteBin6Line } from 'react-icons/ri';
import styles from 'assets/styles/customTable.module.scss';

export const EditButton = ({
  onEdit,
  hidden,
  disabled,
  textContent,
}: {
  hidden?: boolean;
  disabled?: boolean;
  textContent?: string;
  onEdit: (e: any) => void;
}) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    if (disabled) {
      toast.warning('Эту информацию нельзя изменить');
      return;
    }
    onEdit(e);
  };

  return (
    <Button
      id='edit'
      aria-label='edit'
      onClick={handleClick}
      className={styles.button}
      sx={{ display: hidden ? 'none' : null }}>
      <FiEdit3 className={styles.buttonIcon} /> {textContent}
    </Button>
  );
};

export const CloseButton = ({
  onClose,
  disabled,
  hidden,
  textContent,
}: {
  hidden?: boolean;
  disabled?: boolean;
  textContent?: string;
  onClose: (e: any) => void;
}) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    if (disabled) {
      toast.warning('Эту информацию нельзя изменить');
      return;
    }
    onClose(e);
  };

  return (
    <Button
      id='edit'
      aria-label='edit'
      onClick={handleClick}
      className={styles.button}
      sx={{ display: hidden ? 'none' : null }}>
      <AiOutlineStop className={styles.buttonIcon} /> {textContent}
    </Button>
  );
};

export const ShowButton = ({
  onShow,
  disabled,
  hidden,
  textContent,
}: {
  hidden?: boolean;
  disabled?: boolean;
  onShow: (e: any) => void;
  textContent?: string;
}) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    if (disabled) {
      toast.warning('Эту информацию нельзя Просмотр');
      return;
    }
    onShow(e);
  };
  return (
    <Button
      id='show'
      aria-label='show'
      onClick={handleClick}
      className={styles.button}
      sx={{ display: hidden ? 'none' : null }}>
      <AiOutlineEye className={styles.buttonIcon} /> {textContent}
    </Button>
  );
};

export const DeleteButton = ({
  hidden,
  disabled,
  onDelete,
  textContent,
}: {
  hidden?: boolean;
  disabled?: boolean;
  textContent?: string;
  onDelete: (e: any) => void;
}) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    if (disabled) {
      toast.warning('Эту информацию невозможно удалить');
      return;
    }
    onDelete(e);
  };
  return (
    <Button
      id='delete'
      aria-label='delete'
      onClick={handleClick}
      className={styles.button}
      sx={{
        display: hidden ? 'none' : null,
      }}>
      <RiDeleteBin6Line className={styles.buttonIcon} /> {textContent}
    </Button>
  );
};
